import { render, staticRenderFns } from "./ShowPlotting.vue?vue&type=template&id=56fd8484"
import script from "./ShowPlotting.vue?vue&type=script&lang=js"
export * from "./ShowPlotting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports